/**
 * Diccionario de i18n — componentes JS (lotowheel-modals.js + contrato-modal.js)
 *
 * Claves nuevas declaradas durante la pasada 3 de internacionalización.
 * Solo columna `pt` (portugués) es obligatoria en esta fase.
 *
 * Claves REUSADAS (no declaradas aquí, ya existentes):
 *   'Activo'          → diccionario-comunes.js
 *   'Inactivo'        → diccionario-comunes.js
 *   'Guardar'         → diccionario-comunes.js
 *   'Cancelar'        → diccionario-comunes.js
 *   'Editar'          → diccionario-comunes.js
 *   'Eliminar'        → diccionario-comunes.js
 *   'Cargando...'     → diccionario-contrato.js (y otros)
 *   'Nombre'          → diccionario-administracion.js (y otros)
 *   'Tipo'            → diccionario-modales.js (y otros)
 *   'Error al eliminar' → diccionario-marketing.js
 *   'Modo'            → diccionario-lotowheel-extra.js
 *   'Identidad'       → diccionario-lotowheel-extra.js
 *   'Avanzado'        → diccionario-lotowheel-extra.js
 *   'Acceso'          → diccionario-lotowheel-extra.js
 *   'Pozo'            → diccionario-lotowheel-extra.js
 *   'Apuestas'        → diccionario-lotowheel-extra.js
 *   'Moneda'          → diccionario-lotowheel-extra.js
 *   'Idioma'          → diccionario-lotowheel-extra.js
 *   'Activar'         → diccionario-nodos.js / diccionario-marketing.js
 *   'Operador'        → diccionario-nodos.js
 *   'Representante'   → diccionario-nodos.js
 *   'Punto de Venta'  → diccionario-nodos.js
 *   'Heredando de'    → diccionario-nodos.js
 *   'Central (operador raiz)' → diccionario-contrato.js
 *   'Monto fijo'      → diccionario-contrato.js
 *   '(en centavos)'   → diccionario-contrato.js
 *   'Padre directo (por defecto)' → diccionario-contrato.js
 *   'Entidad'         → diccionario-operacion.js
 *   'Sorteo #'        → diccionario-lotowheel-extra.js
 *   'Sin resultados'  → diccionario-lotowheel-extra.js
 *   'Sin comparación' → diccionario-lotowheel-extra.js
 *   'Pausado'         → diccionario-plataforma.js
 *   'Zona de Peligro' → diccionario-modales.js
 *   'Modo'            → diccionario-marketing.js
 *   'Todo'            → diccionario-vistas.js
 *   'Duo'             → diccionario-lotowheel-extra.js
 *   'Trio'            → diccionario-lotowheel-extra.js
 *   'Sexteto'         → diccionario-lotowheel-extra.js
 */

export const DICCIONARIO_COMPONENTES = {
    // Desglose por moneda (popover del ≈ / del hueco en totales consolidados)
    'Desglose por moneda': { pt: 'Detalhe por moeda', en: 'Breakdown by currency', ru: 'Разбивка по валютам' },
    'Ver desglose por moneda': {
        pt: 'Ver detalhe por moeda',
        en: 'View breakdown by currency',
        ru: 'Показать разбивку по валютам',
    },
    'sin cotización': { pt: 'sem cotação', en: 'no exchange rate', ru: 'нет курса' },
    'moneda del total': { pt: 'moeda do total', en: 'currency of the total', ru: 'валюта итога' },
    'Hay nodos sin moneda configurada: su dinero no se pudo convertir': {
        pt: 'Há nós sem moeda configurada: o dinheiro deles não pôde ser convertido',
        en: 'Some nodes have no currency set: their money could not be converted',
        ru: 'У некоторых узлов не задана валюта: их деньги не удалось конвертировать',
    },
    'Faltan tasas de cambio: el total no se pudo consolidar': {
        pt: 'Faltam taxas de câmbio: o total não pôde ser consolidado',
        en: 'Exchange rates are missing: the total could not be consolidated',
        ru: 'Нет курсов валют: итог не удалось свести',
    },
    'Total convertido con la tasa del día: es aproximado': {
        pt: 'Total convertido com a taxa do dia: é aproximado',
        en: 'Total converted at today rate: it is approximate',
        ru: 'Итог пересчитан по курсу дня: приблизительный',
    },
    // ── lotowheel-modals.js — modal configuración ─────────────────────────

    'Configurar Sorteo': { pt: 'Configurar Sorteio', en: 'Configure Draw', ru: 'Настроить розыгрыш' },
    General: { pt: 'Geral', en: 'General', ru: 'Общее' },
    'Nombre e idioma': { pt: 'Nome e idioma', en: 'Name and language', ru: 'Название и язык' },
    Rueda: { pt: 'Roda', en: 'Wheel', ru: 'Колесо' },
    '37, 38 o 13 sectores': { pt: '37, 38 ou 13 setores', en: '37, 38 or 13 sectors', ru: '37, 38 или 13 секторов' },
    Algoritmo: { pt: 'Algoritmo', en: 'Algorithm', ru: 'Алгоритм' },
    'Resolver y presets': { pt: 'Resolver e predefinições', en: 'Resolver and presets', ru: 'Резолвер и пресеты' },
    Apariencia: { pt: 'Aparência', en: 'Appearance', ru: 'Внешний вид' },
    'Tema y sonidos': { pt: 'Tema e sons', en: 'Theme and sounds', ru: 'Тема и звуки' },
    'Visibilidad por operador': {
        pt: 'Visibilidade por operador',
        en: 'Visibility by operator',
        ru: 'Видимость по оператору',
    },
    'Tipos y multiplicadores': { pt: 'Tipos e multiplicadores', en: 'Types and multipliers', ru: 'Типы и множители' },
    Fichas: { pt: 'Fichas', en: 'Chips', ru: 'Фишки' },
    'Valores y pago max': {
        pt: 'Valores e pagamento máx',
        en: 'Values and max payout',
        ru: 'Значения и макс. выплата',
    },
    'Divisa y formato': { pt: 'Divisa e formato', en: 'Currency and format', ru: 'Валюта и формат' },
    Tiempos: { pt: 'Tempos', en: 'Timing', ru: 'Время' },
    'Cierre y avisos': { pt: 'Fechamento e avisos', en: 'Closing and alerts', ru: 'Закрытие и уведомления' },
    Animacion: { pt: 'Animação', en: 'Animation', ru: 'Анимация' },
    'Giro de la rueda': { pt: 'Giro da roda', en: 'Wheel spin', ru: 'Вращение колеса' },
    Juego: { pt: 'Jogo', en: 'Game', ru: 'Игра' },

    // Panel General
    'Nombre del Sorteo': { pt: 'Nome do Sorteio', en: 'Draw Name', ru: 'Название розыгрыша' },
    'Sorteo temporizado': { pt: 'Sorteio programado', en: 'Scheduled draw', ru: 'Розыгрыш по расписанию' },
    'Draw individual': { pt: 'Draw individual', en: 'Individual draw', ru: 'Индивидуальная игра' },
    'Ambas modalidades': { pt: 'Ambas as modalidades', en: 'Both modes', ru: 'Оба режима' },
    'Ej: Fortuna Royal': { pt: 'Ex: Fortuna Royal', en: 'E.g.: Fortuna Royal', ru: 'Напр.: Fortuna Royal' },
    Espanol: { pt: 'Espanhol', en: 'Spanish', ru: 'Испанский' },
    Portugues: { pt: 'Português', en: 'Portuguese', ru: 'Португальский' },
    'Intervalo (segundos)': { pt: 'Intervalo (segundos)', en: 'Interval (seconds)', ru: 'Интервал (секунды)' },
    'Tiempo entre sorteos (30-300s)': {
        pt: 'Tempo entre sorteios (30-300s)',
        en: 'Time between draws (30-300s)',
        ru: 'Время между розыгрышами (30-300с)',
    },
    'Eliminar Sorteo': { pt: 'Excluir Sorteio', en: 'Delete Draw', ru: 'Удалить розыгрыш' },
    'Esta accion no se puede deshacer': {
        pt: 'Esta ação não pode ser desfeita',
        en: 'This action cannot be undone',
        ru: 'Это действие нельзя отменить',
    },

    // Panel Apuestas (bet toggles)
    'Seleccion Directa': { pt: 'Seleção Direta', en: 'Direct Selection', ru: 'Прямой выбор' },
    'Premios sobre numeros especificos en el panel de apuesta': {
        pt: 'Prêmios sobre números específicos no painel de aposta',
        en: 'Prizes on specific numbers in the bet panel',
        ru: 'Призы за конкретные числа на панели ставок',
    },
    '2 numeros adyacentes': { pt: '2 números adjacentes', en: '2 adjacent numbers', ru: '2 соседних числа' },
    'LOTO con 1, 2 o 3': { pt: 'LOTO com 1, 2 ou 3', en: 'LOTO with 1, 2 or 3', ru: 'LOTO с 1, 2 или 3' },
    'Fila de 3 numeros': { pt: 'Fila de 3 números', en: 'Row of 3 numbers', ru: 'Ряд из 3 чисел' },
    'Esquina de 4 numeros': { pt: 'Esquina de 4 números', en: 'Corner of 4 numbers', ru: 'Угол из 4 чисел' },
    '2 filas (6 numeros)': { pt: '2 filas (6 números)', en: '2 rows (6 numbers)', ru: '2 ряда (6 чисел)' },
    Cualitativa: { pt: 'Qualitativa', en: 'Qualitative', ru: 'Качественная' },
    'Premios por propiedades del numero': {
        pt: 'Prêmios por propriedades do número',
        en: 'Prizes by number properties',
        ru: 'Призы по свойствам числа',
    },
    'Rojo / Negro': { pt: 'Vermelho / Preto', en: 'Red / Black', ru: 'Красное / Чёрное' },
    'Color del numero': { pt: 'Cor do número', en: 'Number color', ru: 'Цвет числа' },
    'Par / Impar': { pt: 'Par / Ímpar', en: 'Even / Odd', ru: 'Чёт / Нечёт' },
    'Paridad del numero': { pt: 'Paridade do número', en: 'Number parity', ru: 'Чётность числа' },
    'Mitad (1-18 / 19-36)': { pt: 'Metade (1-18 / 19-36)', en: 'Half (1-18 / 19-36)', ru: 'Половина (1-18 / 19-36)' },
    'Primera o segunda mitad': {
        pt: 'Primeira ou segunda metade',
        en: 'First or second half',
        ru: 'Первая или вторая половина',
    },
    Grupos: { pt: 'Grupos', en: 'Groups', ru: 'Группы' },
    'Conjuntos predefinidos de numeros': {
        pt: 'Conjuntos predefinidos de números',
        en: 'Predefined sets of numbers',
        ru: 'Предопределённые наборы чисел',
    },
    Tercios: { pt: 'Terços', en: 'Thirds', ru: 'Трети' },
    Columnas: { pt: 'Colunas', en: 'Columns', ru: 'Столбцы' },
    'Columnas verticales del panel de apuesta': {
        pt: 'Colunas verticais do painel de aposta',
        en: 'Vertical columns of the bet panel',
        ru: 'Вертикальные столбцы панели ставок',
    },
    'Bloques (A-F)': { pt: 'Blocos (A-F)', en: 'Blocks (A-F)', ru: 'Блоки (A-F)' },
    'Sectores fisicos de la rueda': {
        pt: 'Setores físicos da roda',
        en: 'Physical sectors of the wheel',
        ru: 'Физические секторы колеса',
    },
    Espejos: { pt: 'Espelhos', en: 'Mirrors', ru: 'Зеркала' },
    'Numeros invertidos (12-21, 13-31, 23-32)': {
        pt: 'Números invertidos (12-21, 13-31, 23-32)',
        en: 'Inverted numbers (12-21, 13-31, 23-32)',
        ru: 'Перевёрнутые числа (12-21, 13-31, 23-32)',
    },

    // Panel Resolver
    Preset: { pt: 'Predefinição', en: 'Preset', ru: 'Пресет' },
    'Guardar actual': { pt: 'Salvar atual', en: 'Save current', ru: 'Сохранить текущий' },
    'Buscar o seleccionar preset...': {
        pt: 'Buscar ou selecionar predefinição...',
        en: 'Search or select preset...',
        ru: 'Найти или выбрать пресет...',
    },

    // Panel Visual
    'Pack de Sonidos': { pt: 'Pacote de Sons', en: 'Sound Pack', ru: 'Звуковой пакет' },
    Clasico: { pt: 'Clássico', en: 'Classic', ru: 'Классический' },
    'Efecto Inicio': { pt: 'Efeito Início', en: 'Start Effect', ru: 'Эффект начала' },
    'Efecto Final': { pt: 'Efeito Final', en: 'End Effect', ru: 'Эффект окончания' },
    'Efectos del Sorteo': { pt: 'Efeitos do Sorteio', en: 'Draw Effects', ru: 'Эффекты розыгрыша' },
    Ninguno: { pt: 'Nenhum', en: 'None', ru: 'Нет' },
    'Logos / Branding': { pt: 'Logos / Branding', en: 'Logos / Branding', ru: 'Логотипы / Брендинг' },
    'Logo Centro Rueda': { pt: 'Logo Centro da Roda', en: 'Wheel Center Logo', ru: 'Логотип в центре колеса' },
    'Logo Sorteo': { pt: 'Logo Sorteio', en: 'Draw Logo', ru: 'Логотип розыгрыша' },
    'Logo Zero': { pt: 'Logo Zero', en: 'Zero Logo', ru: 'Логотип зеро' },
    'PNG, SVG o WebP con transparencia — max 2MB': {
        pt: 'PNG, SVG ou WebP com transparência — máx 2MB',
        en: 'PNG, SVG or WebP with transparency — max 2MB',
        ru: 'PNG, SVG или WebP с прозрачностью — макс. 2 МБ',
    },
    Cambiar: { pt: 'Alterar', en: 'Change', ru: 'Изменить' },

    // Panel Tipo (rueda)
    'Fortuna Clasica (37 sectores: 0-36)': {
        pt: 'Fortuna Clássica (37 setores: 0-36)',
        en: 'Classic Fortuna (37 sectors: 0-36)',
        ru: 'Классическая Fortuna (37 секторов: 0-36)',
    },
    'Fortuna Americana (38 sectores: 0, 00, 1-36)': {
        pt: 'Fortuna Americana (38 setores: 0, 00, 1-36)',
        en: 'American Fortuna (38 sectors: 0, 00, 1-36)',
        ru: 'Американская Fortuna (38 секторов: 0, 00, 1-36)',
    },
    'Fortuna Triple Cero (39 sectores)': {
        pt: 'Fortuna Triplo Zero (39 setores)',
        en: 'Triple Zero Fortuna (39 sectors)',
        ru: 'Fortuna с тройным зеро (39 секторов)',
    },
    'Mini Fortuna (13 sectores: 0-12)': {
        pt: 'Mini Fortuna (13 setores: 0-12)',
        en: 'Mini Fortuna (13 sectors: 0-12)',
        ru: 'Мини Fortuna (13 секторов: 0-12)',
    },
    'Midi Fortuna (19 sectores: 0-18)': {
        pt: 'Midi Fortuna (19 setores: 0-18)',
        en: 'Midi Fortuna (19 sectors: 0-18)',
        ru: 'Миди Fortuna (19 секторов: 0-18)',
    },
    'Rueda 10 (11 sectores: 0-10)': {
        pt: 'Roda 10 (11 setores: 0-10)',
        en: 'Wheel 10 (11 sectors: 0-10)',
        ru: 'Колесо 10 (11 секторов: 0-10)',
    },
    'Rueda 10 Americana (12 sectores: 0, 00, 1-10)': {
        pt: 'Roda 10 Americana (12 setores: 0, 00, 1-10)',
        en: 'American Wheel 10 (12 sectors: 0, 00, 1-10)',
        ru: 'Американское колесо 10 (12 секторов: 0, 00, 1-10)',
    },
    'Rueda Loterica de la Fortuna': {
        pt: 'Roda Lotérica da Fortuna',
        en: 'Fortuna Lottery Wheel',
        ru: 'Лотерейное колесо Fortuna',
    },
    'FM Quesitos': { pt: 'FM Quesitos', en: 'FM Quesitos', ru: 'FM Quesitos' },
    'Cambiar el tipo de rueda afecta multiplicadores, rangos de apuestas y opciones disponibles': {
        pt: 'Alterar o tipo de roda afeta multiplicadores, faixas de apostas e opções disponíveis',
        en: 'Changing the wheel type affects multipliers, bet ranges and available options',
        ru: 'Изменение типа колеса влияет на множители, диапазоны ставок и доступные опции',
    },

    // Panel Acceso
    'Buscar operador por nombre...': {
        pt: 'Buscar operador por nome...',
        en: 'Search operator by name...',
        ru: 'Найти оператора по имени...',
    },
    'Marcar todos': { pt: 'Marcar todos', en: 'Select all', ru: 'Отметить все' },
    'Desmarcar todos': { pt: 'Desmarcar todos', en: 'Deselect all', ru: 'Снять все отметки' },
    'Agregar partner': { pt: 'Adicionar parceiro', en: 'Add partner', ru: 'Добавить партнёра' },
    'Assets para Integradores': {
        pt: 'Assets para Integradores',
        en: 'Assets for Integrators',
        ru: 'Ресурсы для интеграторов',
    },
    'Imágenes que aparecen en el catálogo de juegos del operador externo': {
        pt: 'Imagens que aparecem no catálogo de jogos do operador externo',
        en: 'Images that appear in the external operator game catalog',
        ru: 'Изображения, отображаемые в каталоге игр внешнего оператора',
    },
    '16:9 — Card del catálogo': {
        pt: '16:9 — Card do catálogo',
        en: '16:9 — Catalog card',
        ru: '16:9 — Карточка каталога',
    },
    '1:1 — Lobby del casino': { pt: '1:1 — Lobby do cassino', en: '1:1 — Casino lobby', ru: '1:1 — Лобби казино' },
    'Se ajustará a 1:1': { pt: 'Será ajustado para 1:1', en: 'Will be adjusted to 1:1', ru: 'Будет подогнано под 1:1' },
    'Se ajustará a 2:1': { pt: 'Será ajustado para 2:1', en: 'Will be adjusted to 2:1', ru: 'Будет подогнано под 2:1' },
    'Se ajustará a 3:1': { pt: 'Será ajustado para 3:1', en: 'Will be adjusted to 3:1', ru: 'Будет подогнано под 3:1' },
    'Opcional: asigná una serie específica a un integrador externo (identificado por su partner_code). Formato: letras, números, guiones o underscores — sin espacios.':
        {
            pt: 'Opcional: atribua uma série específica a um integrador externo (identificado pelo seu partner_code). Formato: letras, números, hífens ou underscores — sem espaços.',
            en: 'Optional: assign a specific series to an external integrator (identified by its partner_code). Format: letters, numbers, hyphens or underscores — no spaces.',
            ru: 'Опционально: назначьте конкретную серию внешнему интегратору (идентифицируемому по его partner_code). Формат: буквы, цифры, дефисы или подчёркивания — без пробелов.',
        },
    'Series de tickets (override por sorteo)': {
        pt: 'Séries de tickets (override por sorteio)',
        en: 'Ticket series (per-draw override)',
        ru: 'Серии билетов (переопределение по розыгрышу)',
    },
    'Dejá en "Heredar" para usar la serie del operador o la default global': {
        pt: 'Deixe em "Herdar" para usar a série do operador ou a padrão global',
        en: 'Leave on "Inherit" to use the operator series or the global default',
        ru: 'Оставьте «Наследовать», чтобы использовать серию оператора или глобальное значение по умолчанию',
    },

    // Panel Fichas
    'Fichas Disponibles': { pt: 'Fichas Disponíveis', en: 'Available Chips', ru: 'Доступные фишки' },
    'Agregar Ficha': { pt: 'Adicionar Ficha', en: 'Add Chip', ru: 'Добавить фишку' },
    'Premio Maximo (centavos)': {
        pt: 'Prêmio Máximo (centavos)',
        en: 'Maximum Prize (cents)',
        ru: 'Максимальный приз (центы)',
    },
    'Apuesta max pleno = Premio / 36': {
        pt: 'Aposta máx. pleno = Prêmio / 36',
        en: 'Max straight bet = Prize / 36',
        ru: 'Макс. ставка на число = Приз / 36',
    },
    'Monto max. por apuesta': { pt: 'Valor máx. por aposta', en: 'Max amount per bet', ru: 'Макс. сумма на ставку' },

    // Panel Moneda
    'Denominacion Base (centavos)': {
        pt: 'Denominação Base (centavos)',
        en: 'Base Denomination (cents)',
        ru: 'Базовый номинал (центы)',
    },
    '100 = 1 unidad de moneda': {
        pt: '100 = 1 unidade de moeda',
        en: '100 = 1 currency unit',
        ru: '100 = 1 единица валюты',
    },
    Simbolo: { pt: 'Símbolo', en: 'Symbol', ru: 'Символ' },
    'Separador Decimal': { pt: 'Separador Decimal', en: 'Decimal Separator', ru: 'Десятичный разделитель' },
    'Separador Miles': { pt: 'Separador de Milhar', en: 'Thousands Separator', ru: 'Разделитель тысяч' },
    Decimales: { pt: 'Decimais', en: 'Decimals', ru: 'Десятичные знаки' },
    'Vigencia de tickets (dias)': {
        pt: 'Validade de tickets (dias)',
        en: 'Ticket validity (days)',
        ru: 'Срок действия билетов (дни)',
    },
    'Dias que tiene el portador para cobrar un ticket ganador': {
        pt: 'Dias que o portador tem para cobrar um ticket ganhador',
        en: 'Days the bearer has to redeem a winning ticket',
        ru: 'Дней у предъявителя на получение выигрышного билета',
    },

    // Panel Timing
    'Inicio sorteo': { pt: 'Início do sorteio', en: 'Draw start', ru: 'Начало розыгрыша' },
    'Cierre Apuestas (seg)': {
        pt: 'Fechamento de Apostas (seg)',
        en: 'Bet Closing (sec)',
        ru: 'Закрытие ставок (сек)',
    },
    'Segundos antes del sorteo para cerrar': {
        pt: 'Segundos antes do sorteio para fechar',
        en: 'Seconds before the draw to close',
        ru: 'Секунд до розыгрыша для закрытия',
    },
    'Cierre apuestas': { pt: 'Fechamento de apostas', en: 'Bet closing', ru: 'Закрытие ставок' },
    'Segundos antes del cierre para avisar': {
        pt: 'Segundos antes do fechamento para avisar',
        en: 'Seconds before closing to alert',
        ru: 'Секунд до закрытия для предупреждения',
    },
    'Tiempo Min Util (seg)': {
        pt: 'Tempo Mín. Útil (seg)',
        en: 'Min Useful Time (sec)',
        ru: 'Мин. полезное время (сек)',
    },
    'Tiempo minimo para permitir apuestas': {
        pt: 'Tempo mínimo para permitir apostas',
        en: 'Minimum time to allow bets',
        ru: 'Минимальное время для приёма ставок',
    },
    'Timeline ejemplo (intervalo 60s):': {
        pt: 'Linha do tempo exemplo (intervalo 60s):',
        en: 'Example timeline (60s interval):',
        ru: 'Пример таймлайна (интервал 60с):',
    },

    // Panel Spin
    'Duracion Total (ms)': { pt: 'Duração Total (ms)', en: 'Total Duration (ms)', ru: 'Общая длительность (мс)' },
    'Duracion de la animacion de rueda': {
        pt: 'Duração da animação da roda',
        en: 'Wheel animation duration',
        ru: 'Длительность анимации колеса',
    },
    Aceleracion: { pt: 'Aceleração', en: 'Acceleration', ru: 'Ускорение' },
    Desaceleracion: { pt: 'Desaceleração', en: 'Deceleration', ru: 'Замедление' },
    'Tension Final': { pt: 'Tensão Final', en: 'Final Tension', ru: 'Финальное напряжение' },
    'Correction Delay (ms)': { pt: 'Correction Delay (ms)', en: 'Correction Delay (ms)', ru: 'Correction Delay (мс)' },
    'Duracion Spin (seg)': { pt: 'Duração Spin (seg)', en: 'Spin Duration (sec)', ru: 'Длительность вращения (сек)' },
    'Resultado y animacion': { pt: 'Resultado e animação', en: 'Result and animation', ru: 'Результат и анимация' },
    'Timeout (seg)': { pt: 'Timeout (seg)', en: 'Timeout (sec)', ru: 'Тайм-аут (сек)' },
    'Modo Espera': { pt: 'Modo Espera', en: 'Standby Mode', ru: 'Режим ожидания' },
    'Operación normal': { pt: 'Operação normal', en: 'Normal operation', ru: 'Обычная работа' },
    Crucero: { pt: 'Cruzeiro', en: 'Cruise', ru: 'Круиз' },
    'Parametros Avanzados': { pt: 'Parâmetros Avançados', en: 'Advanced Parameters', ru: 'Расширенные параметры' },

    // Panel Pozos
    'Selecciona los jackpots a los que contribuirá este sorteo y configura el porcentaje de cada apuesta que se aporta al bote.':
        {
            pt: 'Selecione os jackpots aos quais este sorteio contribuirá e configure o percentual de cada aposta que vai para o pote.',
            en: 'Select the jackpots this draw will contribute to and configure the percentage of each bet that goes to the pool.',
            ru: 'Выберите джекпоты, в которые будет вносить вклад этот розыгрыш, и настройте процент от каждой ставки, направляемый в пул.',
        },

    // Panel Visual — Ceros
    'Visualizacion de los ceros': { pt: 'Visualização dos zeros', en: 'Zero display', ru: 'Отображение зеро' },
    'Como se muestra el cero al jugador en tiquetes, historial y resultados': {
        pt: 'Como o zero é exibido ao jogador em tickets, histórico e resultados',
        en: 'How the zero is shown to the player on tickets, history and results',
        ru: 'Как зеро отображается игроку в билетах, истории и результатах',
    },
    'Por numero del sector (13, 19, 37, 38, 39)': {
        pt: 'Por número do setor (13, 19, 37, 38, 39)',
        en: 'By sector number (13, 19, 37, 38, 39)',
        ru: 'По номеру сектора (13, 19, 37, 38, 39)',
    },
    'Por ceros (0, 00, 000)': { pt: 'Por zeros (0, 00, 000)', en: 'By zeros (0, 00, 000)', ru: 'По зеро (0, 00, 000)' },
    'Texto personalizado (LOTO, LOTO+, LOTO++)': {
        pt: 'Texto personalizado (LOTO, LOTO+, LOTO++)',
        en: 'Custom text (LOTO, LOTO+, LOTO++)',
        ru: 'Произвольный текст (LOTO, LOTO+, LOTO++)',
    },
    'Etiquetas personalizadas por cero': {
        pt: 'Etiquetas personalizadas por zero',
        en: 'Custom labels per zero',
        ru: 'Произвольные метки для каждого зеро',
    },
    'Cero 1': { pt: 'Zero 1', en: 'Zero 1', ru: 'Зеро 1' },
    'Cero 2': { pt: 'Zero 2', en: 'Zero 2', ru: 'Зеро 2' },
    'Cero 3': { pt: 'Zero 3', en: 'Zero 3', ru: 'Зеро 3' },
    'Cada cero tiene 2 lineas: arriba (label chico) y abajo (numero grande). El ancho maximo se ajusta al tipo de rueda para que todo se vea limpio.':
        {
            pt: 'Cada zero tem 2 linhas: acima (label pequeno) e abaixo (número grande). A largura máxima se ajusta ao tipo de roda para que tudo fique limpo.',
            en: 'Each zero has 2 lines: top (small label) and bottom (large number). The maximum width adjusts to the wheel type so everything looks clean.',
            ru: 'У каждого зеро 2 строки: сверху (маленькая метка) и снизу (крупное число). Максимальная ширина подстраивается под тип колеса, чтобы всё выглядело аккуратно.',
        },
    'Vista previa en la rueda': {
        pt: 'Pré-visualização na roda',
        en: 'Preview on the wheel',
        ru: 'Предпросмотр на колесе',
    },
    Mostrar: { pt: 'Mostrar', en: 'Show', ru: 'Показать' },
    'Solo Rueda': { pt: 'Só Roda', en: 'Wheel Only', ru: 'Только колесо' },
    'Solo Stats': { pt: 'Só Estatísticas', en: 'Stats Only', ru: 'Только статистика' },
    'Icono (cuadrado)': { pt: 'Ícone (quadrado)', en: 'Icon (square)', ru: 'Значок (квадратный)' },
    'Thumbnail (banner)': { pt: 'Miniatura (banner)', en: 'Thumbnail (banner)', ru: 'Миниатюра (баннер)' },

    // Simulador
    'Simulador de Ecosistema': {
        pt: 'Simulador de Ecossistema',
        en: 'Ecosystem Simulator',
        ru: 'Симулятор экосистемы',
    },
    'Ejecutar Simulación': { pt: 'Executar Simulação', en: 'Run Simulation', ru: 'Запустить симуляцию' },
    Simular: { pt: 'Simular', en: 'Simulate', ru: 'Симулировать' },
    Escenario: { pt: 'Cenário', en: 'Scenario', ru: 'Сценарий' },
    'Cantidad de sorteos': { pt: 'Quantidade de sorteios', en: 'Number of draws', ru: 'Количество розыгрышей' },
    'Jugadores por punto de venta': {
        pt: 'Jogadores por ponto de venda',
        en: 'Players per point of sale',
        ru: 'Игроков на точку продаж',
    },
    'Apuestas promedio por boleto': {
        pt: 'Apostas médias por boleto',
        en: 'Average bets per ticket',
        ru: 'Среднее число ставок на билет',
    },
    'Boletos por sorteo': { pt: 'Boletos por sorteio', en: 'Tickets per draw', ru: 'Билетов на розыгрыш' },
    'Jugador retira si gana mas de': {
        pt: 'Jogador retira se ganhar mais de',
        en: 'Player withdraws if winning more than',
        ru: 'Игрок делает вывод, если выигрыш больше',
    },
    'Simula hasta recuperar el monto': {
        pt: 'Simula até recuperar o valor',
        en: 'Simulates until the amount is recovered',
        ru: 'Симулирует до возврата суммы',
    },
    '% venta en ticket impreso': {
        pt: '% venda em ticket impresso',
        en: '% sales on printed ticket',
        ru: '% продаж в печатном билете',
    },
    'Déficit inicial': { pt: 'Déficit inicial', en: 'Initial deficit', ru: 'Начальный дефицит' },
    'Comparar con': { pt: 'Comparar com', en: 'Compare with', ru: 'Сравнить с' },
    'Local nuevo': { pt: 'Local novo', en: 'New venue', ru: 'Новая точка' },
    'Puntos de venta': { pt: 'Pontos de venda', en: 'Points of sale', ru: 'Точки продаж' },
    'Fases (deben sumar 1.0)': {
        pt: 'Fases (devem somar 1.0)',
        en: 'Phases (must sum to 1.0)',
        ru: 'Фазы (должны в сумме давать 1.0)',
    },
    'Apuesta concentrada': { pt: 'Aposta concentrada', en: 'Concentrated bet', ru: 'Концентрированная ставка' },
    Limpiar: { pt: 'Limpar', en: 'Clear', ru: 'Очистить' },

    // ── contrato-modal.js ─────────────────────────────────────────────────

    'Nuevo Contrato - ': { pt: 'Novo Contrato - ', en: 'New Contract - ', ru: 'Новый договор - ' },
    'Crear Contrato': { pt: 'Criar Contrato', en: 'Create Contract', ru: 'Создать договор' },
    'Editar Contrato - ': { pt: 'Editar Contrato - ', en: 'Edit Contract - ', ru: 'Редактировать договор - ' },
    'Guardar Cambios': { pt: 'Salvar Alterações', en: 'Save Changes', ru: 'Сохранить изменения' },
    'Contrato no encontrado': { pt: 'Contrato não encontrado', en: 'Contract not found', ru: 'Договор не найден' },
    'Contrato creado correctamente': {
        pt: 'Contrato criado com sucesso',
        en: 'Contract created successfully',
        ru: 'Договор успешно создан',
    },
    'Contrato actualizado correctamente': {
        pt: 'Contrato atualizado com sucesso',
        en: 'Contract updated successfully',
        ru: 'Договор успешно обновлён',
    },
    'Error al guardar contrato': {
        pt: 'Erro ao salvar contrato',
        en: 'Error saving contract',
        ru: 'Ошибка при сохранении договора',
    },

    // Incentivos
    'No hay incentivos comerciales para esta entidad': {
        pt: 'Não há incentivos comerciais para esta entidade',
        en: 'There are no commercial incentives for this entity',
        ru: 'Для этого субъекта нет коммерческих стимулов',
    },
    'Usa el modulo de Marketing para crear promociones scoped a este nodo': {
        pt: 'Use o módulo de Marketing para criar promoções vinculadas a este nodo',
        en: 'Use the Marketing module to create promotions scoped to this node',
        ru: 'Используйте модуль маркетинга для создания акций, привязанных к этому узлу',
    },
    'Modulo de Marketing no disponible': {
        pt: 'Módulo de Marketing não disponível',
        en: 'Marketing module not available',
        ru: 'Модуль маркетинга недоступен',
    },
    'Cargando plantillas...': { pt: 'Carregando modelos...', en: 'Loading templates...', ru: 'Загрузка шаблонов...' },
    'No hay plantillas de incentivos para nodos': {
        pt: 'Não há modelos de incentivos para nodos',
        en: 'There are no incentive templates for nodes',
        ru: 'Нет шаблонов стимулов для узлов',
    },
    'Selecciona una plantilla': { pt: 'Selecione um modelo', en: 'Select a template', ru: 'Выберите шаблон' },
    Volver: { pt: 'Voltar', en: 'Back', ru: 'Назад' },
    'Error al cargar incentivos': {
        pt: 'Erro ao carregar incentivos',
        en: 'Error loading incentives',
        ru: 'Ошибка при загрузке стимулов',
    },
    'Promoción activada': { pt: 'Promoção ativada', en: 'Promotion activated', ru: 'Акция активирована' },
    'Incentivo eliminado': { pt: 'Incentivo excluído', en: 'Incentive deleted', ru: 'Стимул удалён' },
    'Error al clonar preset': {
        pt: 'Erro ao clonar predefinição',
        en: 'Error cloning preset',
        ru: 'Ошибка при клонировании шаблона',
    },
    'Error al cargar presets': {
        pt: 'Erro ao carregar predefinições',
        en: 'Error loading presets',
        ru: 'Ошибка при загрузке пресетов',
    },

    // Obligaciones
    'Guarde el contrato primero para gestionar obligaciones.': {
        pt: 'Salve o contrato primeiro para gerenciar obrigações.',
        en: 'Save the contract first to manage obligations.',
        ru: 'Сначала сохраните договор, чтобы управлять обязательствами.',
    },
    'Sin obligaciones configuradas.': {
        pt: 'Sem obrigações configuradas.',
        en: 'No obligations configured.',
        ru: 'Обязательства не настроены.',
    },
    'Imp. Estatal': { pt: 'Imp. Estadual', en: 'State Tax', ru: 'Гос. налог' },
    'Imp. Municipal': { pt: 'Imp. Municipal', en: 'Municipal Tax', ru: 'Муниципальный налог' },
    'Fee Plataforma': { pt: 'Taxa Plataforma', en: 'Platform Fee', ru: 'Комиссия платформы' },
    Regalía: { pt: 'Royalty', en: 'Royalty', ru: 'Роялти' },
    'Pozo Común': { pt: 'Poço Comum', en: 'Common Pool', ru: 'Общий пул' },
    Mantenimiento: { pt: 'Manutenção', en: 'Maintenance', ru: 'Обслуживание' },
    Base: { pt: 'Base', en: 'Base', ru: 'База' },
    heredada: { pt: 'herdada', en: 'inherited', ru: 'унаследована' },
    'Error al cargar obligaciones': {
        pt: 'Erro ao carregar obrigações',
        en: 'Error loading obligations',
        ru: 'Ошибка при загрузке обязательств',
    },

    // Wizard obligación — resumen
    'Tipo:': { pt: 'Tipo:', en: 'Type:', ru: 'Тип:' },
    'Cálculo:': { pt: 'Cálculo:', en: 'Calculation:', ru: 'Расчёт:' },
    'Paga:': { pt: 'Paga:', en: 'Pays:', ru: 'Платит:' },
    'Orden:': { pt: 'Ordem:', en: 'Order:', ru: 'Порядок:' },
    heredable: { pt: 'herdável', en: 'inheritable', ru: 'наследуемая' },
    'la operación': { pt: 'a operação', en: 'the operation', ru: 'операция' },
    'el jugador': { pt: 'o jogador', en: 'the player', ru: 'игрок' },
    'condicional (umbral)': { pt: 'condicional (limite)', en: 'conditional (threshold)', ru: 'условная (порог)' },
    sobre: { pt: 'sobre', en: 'on', ru: 'на' },
    'monto fijo': { pt: 'valor fixo', en: 'fixed amount', ru: 'фиксированная сумма' },
    'base neta': { pt: 'base líquida', en: 'net base', ru: 'чистая база' },

    // Wizard obligación — labels monto fijo
    'Monto fijo mínimo': { pt: 'Valor fixo mínimo', en: 'Minimum fixed amount', ru: 'Минимальная фиксированная сумма' },
    'Monto fijo máximo': {
        pt: 'Valor fixo máximo',
        en: 'Maximum fixed amount',
        ru: 'Максимальная фиксированная сумма',
    },

    // crearObligacion
    'Guarde el contrato primero': {
        pt: 'Salve o contrato primeiro',
        en: 'Save the contract first',
        ru: 'Сначала сохраните договор',
    },
    'Código y nombre son requeridos': {
        pt: 'Código e nome são obrigatórios',
        en: 'Code and name are required',
        ru: 'Код и название обязательны',
    },

    // _showHerenciaIndicator
    'Usando valores por defecto del sistema': {
        pt: 'Usando valores padrão do sistema',
        en: 'Using system default values',
        ru: 'Используются системные значения по умолчанию',
    },

    // casillas-agrupadas.js — grupos de sorteos por rueda (modales de nodo, listado de Lotowheel)
    'Sin rueda': { pt: 'Sem roda', en: 'No wheel', ru: 'Без колеса' },
    'Buscar sorteo…': { pt: 'Buscar sorteio…', en: 'Search draw…', ru: 'Поиск розыгрыша…' },
    'Expandir todo': { pt: 'Expandir tudo', en: 'Expand all', ru: 'Развернуть все' },
    'Colapsar todo': { pt: 'Recolher tudo', en: 'Collapse all', ru: 'Свернуть все' },
    'Expandir o colapsar todos los grupos': {
        pt: 'Expandir ou recolher todos os grupos',
        en: 'Expand or collapse all groups',
        ru: 'Развернуть или свернуть все группы',
    },
    'Marcar o desmarcar las visibles de este grupo': {
        pt: 'Marcar ou desmarcar as visíveis deste grupo',
        en: 'Check or uncheck the visible ones in this group',
        ru: 'Отметить или снять отметку с видимых в этой группе',
    },
};
